/* The Woolshire rebrand 2026: reviews (sections/woolshire-reviews.liquid). Vanilla, no library.
   Data: Yotpo's v3 storefront API, the same endpoint Yotpo's own reviews widget calls, so the
   numbers match what Yotpo shows shoppers (Shop app reviews included; the older v1 widget API
   leaves those out). The first page is already in the HTML (server-rendered from the
   yotpo.preloaded_reviews metafield); this script refreshes the numbers, then loads more pages,
   sorts, filters by star, opens review photos, and posts new reviews to Yotpo.
   All review text is set with textContent (user content, never parsed as HTML).
   Home ("mode": "all", 2026-10-03): two streams, merged here newest first: every product's
   reviews (GET /v3/storefront/store/<key>/reviews, the store-wide list; Shop app imports included)
   and the store reviews (/product/yotpo_site_reviews/reviews). Each stream keeps its own page
   cursor and buffer; before N cards are shown, every stream holds at least N unshown reviews (or
   has none left), so the N picked are exactly the next N of the merged order: nothing repeats,
   nothing is skipped. Only orders that can be merged exactly are offered (Newest, With photos;
   Yotpo orders "images" as photo reviews first, each group newest first). Star filters POST
   {"scores":[n]} to both streams. Totals and the star bars are the two bottomlines added up.
   Test hooks: ?ws_review_test=1 opens the form filled with a labelled test review (submitting it
   creates a REAL review: delete it in Yotpo); ?ws_review_dryrun=1 shows the request instead of
   sending it. */
(function () {
  'use strict';
  var API = 'https://api-cdn.yotpo.com';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var WORDS = ['', 'one', 'two', 'three', 'four', 'five'];
  var SORT_TEXT = { date: 'newest first', rating: 'highest rated first', images: 'reviews with photos first', votes_up: 'most helpful first' };
  var SVGNS = 'http://www.w3.org/2000/svg';
  var params = new URLSearchParams(location.search);

  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  function avg2(x) { return (Math.round(Number(x) * 100) / 100).toFixed(2); }
  function dateOf(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
    return m ? { iso: m[0], label: MONTHS[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] } : null;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function star(off, size) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (off) s.setAttribute('class', 'is-off');
    var u = document.createElementNS(SVGNS, 'use');
    u.setAttribute('href', '#ws-i-star');
    s.appendChild(u);
    return s;
  }
  function safeUrl(u) { return typeof u === 'string' && /^https:\/\//.test(u) ? u : ''; }
  function pick(o, a, b) { return o && o[a] != null ? o[a] : (o ? o[b] : undefined); }
  /* Yotpo answers in camelCase (product lists, every POST) or snake_case (the store-wide GET). */
  function norm(r) {
    var imgs = pick(r, 'imagesData', 'images_data') || [];
    return {
      id: r.id, score: r.score, title: r.title, content: r.content,
      createdAt: pick(r, 'createdAt', 'created_at') || '',
      verifiedBuyer: pick(r, 'verifiedBuyer', 'verified_buyer') === true,
      imagesData: imgs.map(function (m) { return { thumbUrl: pick(m, 'thumbUrl', 'thumb_url'), originalUrl: pick(m, 'originalUrl', 'original_url') }; }),
      comment: r.comment && r.comment.content ? { content: r.comment.content } : null,
      user: { displayName: pick(r.user, 'displayName', 'display_name') },
      productId: pick(r, 'productId', 'product_id'),
      about: r.about || null,
      _n: true
    };
  }

  /* One card, identical to snippets/woolshire-review-card.liquid */
  function card(r) {
    if (!r._n) r = norm(r);
    var score = Math.max(0, Math.min(5, Math.round(r.score || 0)));
    var name = (r.user && r.user.displayName) || 'Customer';
    var li = el('li', 'ws-rv ws-rvx__card');
    li.setAttribute('data-rvx-id', String(r.id));
    var top = el('div', 'ws-rvx__top');
    var stars = el('span', 'ws-stars ws-rvx__stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', score + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) stars.appendChild(star(i > score));
    top.appendChild(stars);
    var d = dateOf(r.createdAt);
    if (d) { var t = el('time', 'ws-rvx__date', d.label); t.setAttribute('datetime', d.iso); top.appendChild(t); }
    li.appendChild(top);
    if (r.about && r.about.title) {
      var ab = el('p', 'ws-rvx__about');
      var href = typeof r.about.url === 'string' && /^\/[^\/]/.test(r.about.url) ? r.about.url : '';
      if (href) { var a = el('a', null, r.about.title); a.href = href; ab.appendChild(a); }
      else ab.textContent = r.about.title;
      li.appendChild(ab);
    }
    if (r.title) li.appendChild(el('h3', null, r.title));
    if (r.content) li.appendChild(el('p', 'ws-rvx__body', '"' + r.content + '"'));
    var imgs = (r.imagesData || []).filter(function (m) { return safeUrl(m.thumbUrl) && safeUrl(m.originalUrl); });
    if (imgs.length) {
      var ph = el('div', 'ws-rvx__photos');
      imgs.forEach(function (m, idx) {
        var b = el('button', 'ws-rvx__photo');
        b.type = 'button';
        b.setAttribute('data-rvx-photo', m.originalUrl);
        b.setAttribute('aria-label', 'Open photo ' + (idx + 1) + ' of ' + imgs.length + ' from ' + name + "'s review");
        var im = el('img');
        im.src = m.thumbUrl; im.alt = ''; im.width = 160; im.height = 160;
        im.loading = 'lazy'; im.decoding = 'async';
        b.appendChild(im);
        ph.appendChild(b);
      });
      li.appendChild(ph);
    }
    var who = el('footer', 'ws-rv__who');
    who.appendChild(el('span', 'ws-rvx__name', name));
    if (r.verifiedBuyer) {
      var v = el('span', 'ws-rvx__verified');
      v.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1.2l1.7 1.3 2.1-.2.6 2 1.8 1.2-.8 2 .8 2-1.8 1.2-.6 2-2.1-.2L8 14.8l-1.7-1.3-2.1.2-.6-2-1.8-1.2.8-2-.8-2 1.8-1.2.6-2 2.1.2z"/><path d="M5.4 8.2l1.8 1.8 3.5-3.6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      v.appendChild(document.createTextNode('Verified buyer'));
      who.appendChild(v);
    }
    li.appendChild(who);
    if (r.comment && r.comment.content) {
      var rep = el('div', 'ws-rvx__reply');
      rep.appendChild(el('p', 'ws-rvx__reply-by', 'Reply from The Woolshire'));
      rep.appendChild(el('p', null, r.comment.content));
      li.appendChild(rep);
    }
    return li;
  }

  function Reviews(root) {
    var q = function (s) { return root.querySelector(s); };
    this.root = root;
    this.cfg = JSON.parse(q('[data-rvx-config]').textContent);
    this.list = q('[data-rvx-list]');
    this.status = q('[data-rvx-status]');
    this.more = q('[data-rvx-more]');
    this.sortSel = q('[data-rvx-sort]');
    this.chip = q('[data-rvx-clear]');
    this.empty = q('[data-rvx-empty]');
    this.bars = [].slice.call(root.querySelectorAll('[data-rvx-star]'));
    this.lb = q('[data-rvx-lb]');
    var ssr = [].slice.call(this.list.querySelectorAll('[data-rvx-id]')).map(function (li) { return li.getAttribute('data-rvx-id'); });
    this.st = {
      sort: 'date', star: 0, total: this.cfg.total || 0, dist: null,
      pages: ssr.length ? 1 : 0, ids: ssr.map(String), touched: false, req: 0
    };
    this.per = this.cfg.perPage || 5;
    this.all = this.cfg.mode === 'all';
    this.bind();
    if (ssr.length && !this.cfg.store) this.setMore();
    if (this.all) this.feedStart(true);
    else this.refresh();
    this.initForm();
  }

  Reviews.prototype.url = function (page) {
    return API + '/v3/storefront/store/' + encodeURIComponent(this.cfg.appKey) + '/product/' +
      encodeURIComponent(this.cfg.productId) + '/reviews?page=' + page + '&perPage=' + this.per +
      '&sort=' + encodeURIComponent(this.st.sort);
  };

  Reviews.prototype.fetchPage = function (page) {
    var opts = this.st.star
      ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ scores: [this.st.star] }) }
      : {};
    return fetch(this.url(page), opts).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (j) {
      var d = j.response || j; // v3 answers at the top level
      if (!d || !Array.isArray(d.reviews)) throw new Error('bad response');
      return d;
    });
  };

  Reviews.prototype.bind = function () {
    var self = this;
    this.sortSel.addEventListener('change', function () {
      self.st.sort = self.sortSel.value; self.st.touched = true; self.reset();
    });
    this.bars.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = +b.getAttribute('data-rvx-star');
        self.st.star = self.st.star === n ? 0 : n;
        self.st.touched = true;
        self.reset();
      });
    });
    this.chip.addEventListener('click', function () {
      var n = self.st.star;
      self.st.star = 0; self.reset();
      var b = self.bars.filter(function (x) { return +x.getAttribute('data-rvx-star') === n; })[0];
      if (b) b.focus();
    });
    this.more.addEventListener('click', function () { self.loadMore(); });
    this.list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rvx-photo]');
      if (!b) return;
      var all = [].slice.call(b.parentNode.querySelectorAll('[data-rvx-photo]'));
      var cardEl = b.closest('.ws-rvx__card');
      var nm = cardEl && cardEl.querySelector('.ws-rvx__name');
      self.openLb(all.map(function (x) { return x.getAttribute('data-rvx-photo'); }), all.indexOf(b), nm ? nm.textContent : '', b);
    });
    // lightbox
    var lb = this.lb;
    lb.querySelector('[data-rvx-lbclose]').addEventListener('click', function () { lb.close(); });
    lb.querySelector('[data-rvx-lbprev]').addEventListener('click', function () { self.showLb(self.lbI - 1); });
    lb.querySelector('[data-rvx-lbnext]').addEventListener('click', function () { self.showLb(self.lbI + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.showLb(self.lbI - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.showLb(self.lbI + 1); }
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('ws-rvx__lbin')) lb.close();
    });
    lb.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (self.lbOpener && document.contains(self.lbOpener)) self.lbOpener.focus();
    });
  };

  /* Page 1 with the default view: refreshes every number on the page (summary, bars, the buy-box
     star line) and replaces the server-rendered cards only if Yotpo has newer ones. */
  Reviews.prototype.refresh = function () {
    var self = this, token = ++this.st.req;
    var hadSsr = this.st.ids.length > 0;
    if (!hadSsr && this.cfg.store === false) this.list.setAttribute('aria-busy', 'true');
    var saved = { sort: this.st.sort, star: this.st.star };
    this.st.sort = 'date'; this.st.star = 0;
    var p = this.fetchPage(1);
    this.st.sort = saved.sort; this.st.star = saved.star;
    p.then(function (d) {
      if (d.bottomline) self.applyBottomline(d.bottomline);
      if (token !== self.st.req || self.st.touched) return;
      self.st.total = (d.pagination && d.pagination.total) || self.st.total;
      var ids = d.reviews.map(function (r) { return String(r.id); });
      if (self.cfg.store || ids.join() !== self.st.ids.join()) self.render(d.reviews, true);
      self.st.pages = 1;
      self.done();
    }).catch(function () {
      if (token !== self.st.req) return;
      self.list.setAttribute('aria-busy', 'false');
      if (!self.list.children.length) self.fail('Reviews could not load just now.', function () { self.refresh(); });
      else if (!self.cfg.store) self.done(); // the server-rendered reviews stay; Show more retries
      else self.more.hidden = true;
    });
  };

  /* Sort or filter changed: start again from page 1. */
  Reviews.prototype.reset = function () {
    if (this.all) { this.syncControls(); this.clearFail(); this.feedStart(false); return; }
    var self = this, token = ++this.st.req;
    this.syncControls();
    this.clearFail();
    this.list.setAttribute('aria-busy', 'true');
    this.status.textContent = 'Loading reviews…';
    this.fetchPage(1).then(function (d) {
      if (token !== self.st.req) return;
      self.st.total = (d.pagination && d.pagination.total) || 0;
      self.st.pages = 1;
      self.render(d.reviews, true);
      self.done(true);
    }).catch(function () {
      if (token !== self.st.req) return;
      self.list.setAttribute('aria-busy', 'false');
      self.status.textContent = '';
      self.fail('Those reviews could not load just now.', function () { self.reset(); });
    });
  };

  /* Show more: the next two pages (10 reviews) in one round trip. */
  Reviews.prototype.loadMore = function () {
    if (this.all) { this.feedMore(); return; }
    var self = this, token = this.st.req, start = this.st.pages + 1;
    var last = Math.ceil(this.st.total / this.per);
    var pages = [start, start + 1].filter(function (p) { return p <= last; });
    if (!pages.length) return;
    this.clearFail();
    this.more.disabled = true;
    this.more.textContent = 'Loading…';
    this.list.setAttribute('aria-busy', 'true');
    Promise.all(pages.map(function (p) { return self.fetchPage(p); })).then(function (res) {
      if (token !== self.st.req) return;
      var before = self.list.children.length;
      res.forEach(function (d) { self.render(d.reviews, false); });
      self.st.pages += pages.length;
      var first = self.list.children[before];
      if (first) { first.tabIndex = -1; first.focus({ preventScroll: true }); }
      self.done(true);
    }).catch(function () {
      if (token !== self.st.req) return;
      self.list.setAttribute('aria-busy', 'false');
      self.setMore();
      self.fail('More reviews could not load just now.', function () { self.loadMore(); });
    });
  };

  Reviews.prototype.render = function (reviews, replace) {
    var self = this;
    if (replace) { this.list.textContent = ''; this.st.ids = []; }
    var frag = document.createDocumentFragment();
    reviews.forEach(function (r) {
      var id = String(r.id);
      if (self.st.ids.indexOf(id) !== -1) return; // a new review can shift pages by one
      self.st.ids.push(id);
      frag.appendChild(card(r));
    });
    this.list.appendChild(frag);
  };

  Reviews.prototype.done = function (announce) {
    this.list.setAttribute('aria-busy', 'false');
    var n = this.list.children.length;
    if (this.all && this.feed) this.st.total = this.feed.total();
    this.empty.hidden = n > 0;
    if (!n) this.empty.textContent = this.st.star ? 'No ' + WORDS[this.st.star] + '-star reviews yet.' : 'No reviews yet.';
    var what = (this.st.star ? WORDS[this.st.star] + '-star ' : '') + (this.cfg.store && !this.all ? 'store ' : '') + (this.st.total === 1 ? 'review' : 'reviews');
    var text = n ? 'Showing ' + fmt(n) + ' of ' + fmt(this.st.total) + ' ' + what + ', ' + SORT_TEXT[this.st.sort] : '';
    if (announce || this.status.textContent !== text) this.status.textContent = text;
    this.setMore();
  };

  Reviews.prototype.setMore = function () {
    this.more.disabled = false;
    this.more.textContent = 'Show more reviews';
    this.more.hidden = this.all ? !(this.feed && this.feed.hasMore()) : this.list.children.length >= this.st.total;
  };

  /* ---- Home: two streams merged in the browser ("mode": "all") ---- */
  function Feed(cfg, sort, star, per) {
    var base = API + '/v3/storefront/store/' + encodeURIComponent(cfg.appKey) + '/';
    this.cfg = cfg; this.sort = sort; this.star = star; this.per = per;
    this.yp = {}; // Yotpo product id -> { key: Shopify product id, name }
    this.streams = [
      { key: 'product', url: base + 'reviews', page: 0, buf: [], seen: {}, total: 0, done: false, bl: null },
      { key: 'store', url: base + 'product/yotpo_site_reviews/reviews', page: 0, buf: [], seen: {}, total: 0, done: false, bl: null }
    ];
  }
  Feed.prototype.fetch = function (s) {
    var url = s.url + '?page=' + (s.page + 1) + '&perPage=' + this.per + '&sort=' + encodeURIComponent(this.sort);
    var opts = this.star
      ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ scores: [this.star] }) }
      : {};
    return fetch(url, opts).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (j) {
      var d = j.response || j; // a POST answers inside "response", a GET at the top level
      if (!d || !Array.isArray(d.reviews) || !d.pagination) throw new Error('bad response');
      return d;
    });
  };
  /* Fetch pages until the stream holds n unshown reviews or has no more. */
  Feed.prototype.fill = function (s, n) {
    var self = this;
    if (s.done || s.buf.length >= n) return Promise.resolve();
    return this.fetch(s).then(function (d) {
      s.page++;
      s.total = +d.pagination.total || 0;
      if (d.bottomline) s.bl = d.bottomline;
      (d.products || []).forEach(function (p) { self.yp[p.id] = { key: String(pick(p, 'domainKey', 'domain_key')), name: p.name }; });
      d.reviews.forEach(function (raw) {
        var r = norm(raw), id = String(r.id);
        if (s.seen[id]) return; // a new review can shift a page by one
        s.seen[id] = 1;
        r.about = self.about(s, r);
        s.buf.push(r);
      });
      if (!d.reviews.length || s.page * self.per >= s.total) s.done = true;
      return self.fill(s, n);
    });
  };
  Feed.prototype.about = function (s, r) {
    if (s.key === 'store') return { title: this.cfg.storeAbout || 'The Woolshire', url: '' };
    var y = this.yp[r.productId] || {}, p = (this.cfg.products || {})[y.key];
    return p ? { title: p.title, url: p.url } : (y.name ? { title: y.name, url: '' } : null);
  };
  /* Merge order: newest first; "images" puts reviews with photos first, each group newest first. */
  Feed.prototype.before = function (a, b) {
    if (this.sort === 'images') {
      var ia = a.imagesData.length > 0, ib = b.imagesData.length > 0;
      if (ia !== ib) return ia;
    }
    if (a.createdAt !== b.createdAt) return a.createdAt > b.createdAt;
    return +a.id > +b.id;
  };
  Feed.prototype.next = function (n) {
    var self = this;
    return Promise.all(this.streams.map(function (s) { return self.fill(s, n); })).then(function () {
      var out = [];
      while (out.length < n) {
        var best = null;
        self.streams.forEach(function (s) { if (s.buf.length && (!best || self.before(s.buf[0], best.buf[0]))) best = s; });
        if (!best) break;
        out.push(best.buf.shift());
      }
      return out;
    });
  };
  Feed.prototype.total = function () { return this.streams.reduce(function (t, s) { return t + s.total; }, 0); };
  Feed.prototype.hasMore = function () { return this.streams.some(function (s) { return s.buf.length > 0 || !s.done; }); };
  /* Both bottomlines added up (only the unfiltered GETs carry one). */
  Feed.prototype.bottomline = function () {
    var total = 0, sum = 0, dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    for (var i = 0; i < this.streams.length; i++) {
      var b = this.streams[i].bl;
      if (!b) return null;
      var t = pick(b, 'totalReview', 'total_review') || 0, sd = pick(b, 'starDistribution', 'star_distribution');
      if (!sd) return null;
      total += t; sum += t * (pick(b, 'averageScore', 'average_score') || 0);
      for (var k = 1; k <= 5; k++) dist[k] += +sd[k] || 0;
    }
    return { totalReview: total, averageScore: total ? sum / total : 0, starDistribution: dist };
  };

  /* First batch for the current sort/filter. On load (first=true) it keeps the server-rendered
     cards when they already are the newest reviews, so nothing moves. */
  Reviews.prototype.feedStart = function (first) {
    var self = this, token = ++this.st.req;
    var feed = this.feed = new Feed(this.cfg, this.st.sort, this.st.star, 10);
    var n = first ? Math.max(1, this.cfg.initial || 3) : 5;
    this.list.setAttribute('aria-busy', 'true');
    if (!first) this.status.textContent = 'Loading reviews…';
    feed.next(n).then(function (reviews) {
      if (token !== self.st.req) return;
      var bl = feed.bottomline();
      if (bl) self.applyBottomline(bl);
      var ids = reviews.map(function (r) { return String(r.id); });
      if (!first || ids.join() !== self.st.ids.join()) self.render(reviews, true);
      self.done(!first);
    }).catch(function () {
      if (token !== self.st.req) return;
      self.list.setAttribute('aria-busy', 'false');
      self.more.hidden = true;
      if (first && self.list.children.length) { self.status.textContent = ''; return; } // the server-rendered cards stay
      self.status.textContent = '';
      self.list.textContent = ''; self.st.ids = [];
      self.fail('Reviews could not load just now.', function () { self.clearFail(); self.feedStart(first); });
    });
  };
  Reviews.prototype.feedMore = function () {
    var self = this, token = this.st.req;
    this.clearFail();
    this.more.disabled = true;
    this.more.textContent = 'Loading…';
    this.list.setAttribute('aria-busy', 'true');
    this.feed.next(10).then(function (reviews) {
      if (token !== self.st.req) return;
      var before = self.list.children.length;
      self.render(reviews, false);
      var firstNew = self.list.children[before];
      if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({ preventScroll: true }); }
      self.done(true);
    }).catch(function () {
      if (token !== self.st.req) return;
      self.list.setAttribute('aria-busy', 'false');
      self.setMore();
      self.fail('More reviews could not load just now.', function () { self.feedMore(); });
    });
  };

  Reviews.prototype.syncControls = function () {
    var s = this.st.star;
    this.bars.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-rvx-star') === s)); });
    this.chip.hidden = !s;
    if (s) {
      this.chip.textContent = WORDS[s].charAt(0).toUpperCase() + WORDS[s].slice(1) + '-star only';
      this.chip.setAttribute('aria-label', 'Clear filter: ' + WORDS[s] + '-star reviews only');
    }
  };

  Reviews.prototype.fail = function (msg, retry) {
    this.clearFail();
    var p = el('p', 'ws-rvx__err');
    p.setAttribute('role', 'alert');
    p.setAttribute('data-rvx-err', '');
    p.appendChild(document.createTextNode(msg + ' '));
    var b = el('button', 'ws-rvx__textbtn', 'Try again');
    b.type = 'button';
    b.addEventListener('click', retry);
    p.appendChild(b);
    this.list.parentNode.insertBefore(p, this.list.nextSibling);
    if (!this.list.children.length) this.empty.hidden = true;
  };
  Reviews.prototype.clearFail = function () {
    var e = this.root.querySelector('[data-rvx-err]');
    if (e) e.remove();
  };

  /* The numbers: summary, bars, and every star line for this product on the page. */
  Reviews.prototype.applyBottomline = function (b) {
    var total = b.totalReview || 0, dist = b.starDistribution || null, root = this.root;
    var set = function (sel, v) { var e = root.querySelector(sel); if (e) e.textContent = v; };
    if (total) {
      set('[data-rvx-avg]', avg2(b.averageScore));
      set('[data-rvx-total]', fmt(total));
    }
    if (dist) {
      set('[data-rvx-five]', fmt(dist['5'] || 0));
      var fw = root.querySelector('[data-rvx-five-wrap]');
      if (fw) fw.hidden = false;
      this.bars.forEach(function (bt) {
        var n = bt.getAttribute('data-rvx-star'), c = dist[n] || 0;
        bt.querySelector('[data-rvx-n]').textContent = fmt(c);
        bt.querySelector('[data-rvx-fill]').style.width = (total ? Math.round(c / total * 1000) / 10 : 0) + '%';
        bt.disabled = !c && +n !== this.st.star;
      }, this);
      if (!this.cfg.store) {
        var five = fmt(dist['5'] || 0), pid = String(this.cfg.productId);
        document.querySelectorAll('[data-ws-rating-line]').forEach(function (line) {
          if (line.getAttribute('data-ws-rating-line') !== pid) return;
          var live = line.querySelector('[data-ws-rating-live]'), fb = line.querySelector('[data-ws-rating-fallback]');
          if (!live) return;
          live.textContent = (line.getAttribute('data-five-text') || '[count] five-star reviews').replace('[count]', five);
          live.removeAttribute('aria-hidden');
          if (fb) fb.setAttribute('aria-hidden', 'true');
          live.parentNode.classList.remove('is-pending');
        });
      }
    }
  };

  /* Lightbox */
  Reviews.prototype.openLb = function (srcs, i, name, opener) {
    if (typeof this.lb.showModal !== 'function') { window.open(srcs[i], '_blank', 'noopener'); return; }
    this.lbSrcs = srcs; this.lbName = name; this.lbOpener = opener;
    this.lb.querySelector('[data-rvx-lbprev]').hidden = srcs.length < 2;
    this.lb.querySelector('[data-rvx-lbnext]').hidden = srcs.length < 2;
    this.showLb(i);
    document.documentElement.style.overflow = 'hidden';
    this.lb.showModal();
    this.lb.querySelector('[data-rvx-lbclose]').focus();
  };
  Reviews.prototype.showLb = function (i) {
    var n = this.lbSrcs.length;
    this.lbI = (i + n) % n;
    var img = this.lb.querySelector('[data-rvx-lbimg]');
    var label = 'Photo ' + (this.lbI + 1) + ' of ' + n + (this.lbName ? ' from ' + this.lbName + "'s review" : '');
    img.src = this.lbSrcs[this.lbI];
    img.alt = label;
    this.lb.querySelector('[data-rvx-lbcap]').textContent = label;
  };

  /* Write a review: the same request Yotpo's own widget sends (POST /v1/widget/reviews, form
     encoded, appkey + sku = Shopify product id). Creates an unverified review; Yotpo emails the
     reviewer to confirm it and moderates it as usual. */
  Reviews.prototype.initForm = function () {
    var root = this.root, cfg = this.cfg, self = this;
    var wrap = root.querySelector('[data-rvx-write]'), openBtn = root.querySelector('[data-rvx-write-open]');
    if (!wrap || !openBtn || !cfg.product) return;
    var form = wrap.querySelector('[data-rvx-form]'), msg = wrap.querySelector('[data-rvx-formmsg]');
    var rate = form.querySelector('[data-rvx-rate]');
    var radios = [].slice.call(form.querySelectorAll('input[name="review_score"]'));
    var submit = form.querySelector('[type="submit"]');
    var checked = function () { var r = radios.filter(function (x) { return x.checked; })[0]; return r ? r.value : ''; };
    var paint = function (v) { if (v) rate.setAttribute('data-v', v); else rate.removeAttribute('data-v'); };
    radios.forEach(function (r) {
      r.addEventListener('change', function () { paint(checked()); rate.removeAttribute('aria-invalid'); });
      var lab = form.querySelector('label[for="' + r.id + '"]');
      lab.addEventListener('mouseenter', function () { paint(r.value); });
      lab.addEventListener('mouseleave', function () { paint(checked()); });
    });
    var toggle = function (open) {
      wrap.hidden = !open;
      openBtn.setAttribute('aria-expanded', String(open));
      if (open) { form.querySelector('.ws-rvx__formh').setAttribute('tabindex', '-1'); form.querySelector('.ws-rvx__formh').focus(); }
      else openBtn.focus();
    };
    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.value.trim() && e.target.checkValidity()) e.target.removeAttribute('aria-invalid');
      if (msg.classList.contains('is-error') && !form.querySelector('[aria-invalid="true"]')) { msg.textContent = ''; msg.className = 'ws-rvx__formmsg'; }
    });
    openBtn.addEventListener('click', function () { toggle(wrap.hidden); });
    form.querySelector('[data-rvx-write-close]').addEventListener('click', function () { toggle(false); });

    var test = params.get('ws_review_test') === '1', dry = params.get('ws_review_dryrun') === '1';
    if (test) {
      form.querySelector('[data-rvx-test]').hidden = false;
      form.display_name.value = 'Woolshire TEST';
      form.review_title.value = 'TEST review, please delete';
      form.review_content.value = 'Test review sent from the rebrand preview theme to check the custom review form. Please delete it in Yotpo.';
      var r3 = radios.filter(function (x) { return x.value === '3'; })[0];
      if (r3) { r3.checked = true; paint('3'); }
      toggle(true);
      root.scrollIntoView();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.className = 'ws-rvx__formmsg';
      var bad = [];
      ['display_name', 'email', 'review_title', 'review_content'].forEach(function (k) {
        var f = form[k], ok = f.value.trim() !== '' && f.checkValidity();
        f.setAttribute('aria-invalid', String(!ok));
        if (!ok) bad.push(f);
      });
      if (!checked()) { rate.setAttribute('aria-invalid', 'true'); bad.unshift(radios[0]); }
      if (bad.length) {
        msg.classList.add('is-error');
        msg.textContent = 'Please add ' + (checked() ? '' : 'a star rating, ') + 'your name, a valid email, a title and your review.';
        bad[0].focus();
        return;
      }
      var body = new URLSearchParams();
      body.append('review_score', checked());
      body.append('review_title', form.review_title.value.trim());
      body.append('review_content', form.review_content.value.trim());
      body.append('display_name', form.display_name.value.trim());
      body.append('email', form.email.value.trim());
      body.append('appkey', cfg.appKey);
      body.append('review_source', 'widget_v3');
      body.append('sku', String(cfg.productId));
      body.append('product_title', cfg.product.title || '');
      body.append('product_description', cfg.product.description || '');
      body.append('product_url', cfg.product.url || location.origin + location.pathname);
      body.append('product_image_url', cfg.product.image || '');
      if (dry) {
        msg.textContent = 'Dry run, nothing sent. POST ' + API + '/v1/widget/reviews  ' + body.toString();
        if (window.console) console.info('[woolshire-reviews] dry run', API + '/v1/widget/reviews', Object.fromEntries(body));
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Sending…';
      fetch(API + '/v1/widget/reviews', { method: 'POST', body: body }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          var code = j && j.code != null ? +j.code : res.status;
          if (!res.ok || code >= 400) throw new Error('HTTP ' + res.status);
          return j;
        });
      }).then(function () {
        var name = form.display_name.value.trim();
        form.reset(); paint('');
        [].slice.call(form.elements).forEach(function (f) { if (f !== submit) f.disabled = true; });
        submit.hidden = true;
        msg.classList.add('is-ok');
        msg.textContent = 'Thank you, ' + name + '. Yotpo will email you to confirm your review; it appears here once it is published.';
        msg.setAttribute('tabindex', '-1'); msg.focus();
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = 'Submit review';
        msg.classList.add('is-error');
        msg.textContent = 'Sorry, your review did not go through. Please try again in a moment.';
      });
    });
  };

  function boot() {
    document.querySelectorAll('[data-rvx]').forEach(function (root) {
      if (root.__rvx) return;
      try { root.__rvx = new Reviews(root); } catch (e) { if (window.console) console.warn('[woolshire-reviews]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
